import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import User from '@/pages/people-partners/User';
import mapResponse from '@/utils/mapResponse';

EventUser.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  event: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired
};

export default function EventUser(props) {
  const { user, event } = props;

  const invitations = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id,
          request: { $not: 'Outreach' }
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  const invitation = _.find(invitations.data, function(invitation) {
    return invitation.data.userId === user.id;
  });

  const selected = !!invitation;

  return (
    <User
      user={user}
      event={event}
      selected={selected}
      footer={invitation ? mapResponse(invitation.data.response) : undefined}
    />
  );
}
